import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import { useAuth } from '../auth/AuthContext';

export default function RunValidationCell({ runId, value, label, onSaved }) {
  const { user, request } = useAuth();
  const canEdit = user && ['admin', 'administrator'].includes(String(user.role).toLowerCase());
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const titleId = `run-validation-title-${runId}`;
  function edit() {
    setDraft(value || ''); setError(''); setSaved(false); setOpen(true);
  }
  async function save(event) {
    event.preventDefault();
    if (busy) return;
    setError('');
    const url = draft.trim();
    try {
      if (!['http:', 'https:'].includes(new URL(url).protocol)) throw new Error();
    } catch {
      setError('Enter an HTTP or HTTPS evidence URL.');
      return;
    }
    setBusy(true);
    try {
      const result = await request('patch', `/account/runs/${runId}/validation`, { run_validation: url });
      onSaved(result);
      setOpen(false); setSaved(true);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }
  return <div className="run-validation-cell">
    <Link to={`/runs/${runId}`}>{label || 'Mission Log'}</Link>
    {canEdit && <Button size="small" color="primary" onClick={edit} aria-label={`Edit validation for run ${runId}`}>Edit validation</Button>}
    {saved && <span role="status">Saved.</span>}
    <Dialog open={open && !!canEdit} onClose={() => { if (!busy) setOpen(false); }} aria-labelledby={titleId} fullWidth maxWidth="sm">
      <form onSubmit={save}>
        <DialogTitle id={titleId}>Edit run validation</DialogTitle>
        <DialogContent>
          <p>Update the video or screenshot URL for run #{runId}.</p>
          <TextField id={`run-validation-url-${runId}`} label="Evidence URL" type="url" value={draft} onChange={e => setDraft(e.target.value)} autoFocus required fullWidth disabled={busy} inputProps={{ maxLength: 2048 }} margin="normal" />
          {error && <p role="alert">{error}</p>}
        </DialogContent>
        <DialogActions>
          <Button type="button" onClick={() => setOpen(false)} disabled={busy}>Cancel</Button>
          <Button type="submit" color="primary" variant="contained" disabled={busy}>{busy ? 'Saving…' : 'Save'}</Button>
        </DialogActions>
      </form>
    </Dialog>
  </div>;
}
